"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _styles = require("@material-ui/styles");
var _styles2 = require("@material-ui/core/styles");
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: {
      '& .react-calendar': {
        border: 'none'
      },
      // NOW
      '& .react-calendar__tile--now': {
        background: 'none'
      },
      // HEADER
      '& .react-calendar__navigation__label': {
        fontSize: theme.typography.pxToRem(16)
      },
      '& .react-calendar__month-view__weekdays__weekday': {
        textTransform: 'capitalize',
        color: (0, _styles2.alpha)('#000000', 0.12)
      },
      '& .react-calendar__month-view__weekdays__weekday abbr': {
        textDecoration: 'none'
      },
      // DECADE
      '& .react-calendar__century-view__decades__decade': {
        '&::before, &:after': {
          display: 'none'
        }
      },
      // YEAR
      '& .react-calendar__decade-view__years__year': {
        fontSize: theme.typography.pxToRem(14),
        lineHeight: theme.typography.pxToRem(14)
      },
      '& .react-calendar__decade-view .react-calendar__tile': {
        paddingTop: theme.spacing(1.5),
        paddingBottom: theme.spacing(1.5),
        borderRadius: 300,
        position: 'relative',
        '&.react-calendar__tile--hasActive': {
          backgroundColor: theme.palette.BLUE400,
          color: theme.palette.NEUTRAL000
        },
        '&::before, &::after': {
          display: 'none'
        }
      },
      // MONTH
      '& .react-calendar__year-view__months__month': {
        position: 'relative',
        fontSize: 14
      },
      '& .react-calendar__year-view__months__month abbr': {
        width: '100%',
        height: 36,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        borderRadius: 300,
        zIndex: 1,
        position: 'relative'
      },
      '& .react-calendar__year-view__months__month.react-calendar__tile--hasActive': {
        background: 'none'
      },
      '& .react-calendar__year-view .react-calendar__tile': {
        paddingTop: 0,
        paddingBottom: 0
      },
      '& .react-calendar__year-view__months__month.react-calendar__tile--hasActive abbr': {
        backgroundColor: theme.palette.BLUE400,
        color: theme.palette.NEUTRAL000
      },
      // DAYS
      '& .react-calendar__month-view__days__day': {
        fontSize: theme.typography.pxToRem(14),
        lineHeight: theme.typography.pxToRem(14),
        color: theme.palette.NEUTRAL700,
        display: 'flex',
        justifyContent: 'center',
        position: 'relative',
        paddingTop: 0,
        paddingBottom: 0
      },
      '& .react-calendar__month-view__days__day--neighboringMonth': {
        color: theme.palette.NEUTRAL090
      },
      '& .react-calendar__month-view__days__day abbr': {
        width: 40,
        height: 36,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        margin: 0,
        borderRadius: '50%',
        zIndex: 1
      },
      '& .react-calendar__tile:enabled:hover, & .react-calendar__tile:enabled:focus': {
        background: 'none',
        '& abbr': {
          backgroundColor: theme.palette.NEUTRAL040
        }
      },
      '& .react-calendar__tile.react-calendar__tile--active, & .react-calendar__month-view__days__day.react-calendar__tile--hasActive': {
        background: 'none',
        '& abbr': {
          backgroundColor: theme.palette.BLUE400,
          color: theme.palette.NEUTRAL000
        },
        '&:enabled:focus': {
          '& abbr': {
            backgroundColor: theme.palette.BLUE400
          }
        }
      }
    },
    rootRange: {
      '& .react-calendar__tile.react-calendar__tile--active:not([class*="range"])': {
        backgroundColor: theme.palette.BLUE050,
        '& abbr': {
          backgroundColor: 'transparent',
          color: theme.palette.NEUTRAL700
        }
      },
      '& .react-calendar__tile--rangeStart::after, & .react-calendar__tile--rangeEnd::before': {
        content: "''",
        width: '50%',
        height: '100%',
        right: 0,
        top: 0,
        position: 'absolute',
        backgroundColor: theme.palette.BLUE050,
        zIndex: 0
      },
      '& .react-calendar__tile--rangeStart::after': {
        right: 0
      },
      '& .react-calendar__tile--rangeEnd::before': {
        left: 0
      },
      '& .react-calendar__tile--rangeStart.react-calendar__tile--rangeEnd::before': {
        display: 'none'
      }
    }
  };
});
var _default = useStyles;
exports.default = _default;